import { ArticleClient } from 'api/clients/ArticleClient'
import * as HandbookClient from 'api/clients/HandbookClient'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { Workspace } from 'types'
import { metaFromPath } from 'utils/metaFromPath'

export function usePathWorkspace() {
  const location = useLocation()
  const meta = metaFromPath(location.pathname)
  const [workspaceMeta, setWorkspaceMeta] = useState<{ company: Pick<Workspace, 'id'> } | null>(null)

  useEffect(() => {
    if (!meta?.workspaceId) return
    // TODO: Actually try and fetch the company meta to see if it exists
    setWorkspaceMeta({ company: { id: meta?.workspaceId } })
  }, [meta?.workspaceId])

  useEffect(() => {
    let cancelled = false
    // Already found the workspace or don't even know the article key
    if (meta?.workspaceId || !meta?.articleKey) return
    ArticleClient.getWorkspace(meta.articleKey).then((res) => {
      if (res.type === SUCCESS_RESPONSE_TYPE && !cancelled && res.data.company != null) {
        setWorkspaceMeta(res.data)
      }
    })
    return () => {
      cancelled = true
    }
  }, [meta?.workspaceId, meta?.articleKey])

  useEffect(() => {
    let cancelled = false
    // Already found the workspace or don't even know the handbook key
    if (meta?.workspaceId || !meta?.handbookKey) return
    HandbookClient.getHandbookWorkspace(meta.handbookKey).then((res) => {
      if (res.type === SUCCESS_RESPONSE_TYPE && !cancelled && res.data.company != null) {
        setWorkspaceMeta(res.data)
      }
    })
    return () => {
      cancelled = true
    }
  }, [meta?.workspaceId, meta?.handbookKey])

  return workspaceMeta
}
